import { applyMiddleware, combineReducers, createStore, Store } from 'redux'
import thunk, { ThunkMiddleware } from 'redux-thunk'

import { composeWithDevTools } from 'redux-devtools-extension'

import { knivesSetReducer } from '../reducers/knives-set-reducer'
import { wizardReducer } from '~src/reducers/wizard-reducer'
import { appReducer } from '~src/reducers/app-reducer'

export const rootReducer = combineReducers({
  knivesSet: knivesSetReducer,
  wizard: wizardReducer,
  app: appReducer,
})

export type AppState = ReturnType<typeof rootReducer>

const DEVTOOLS_TRACE_ENABLED = false

export default function configureStore(): Store {
  const middleware = [thunk as ThunkMiddleware<AppState>]
  const middlewareEnhancer = applyMiddleware(...middleware)

  const enhancers = [middlewareEnhancer]

  if (DEVTOOLS_TRACE_ENABLED) {
    const composeEnhancers = composeWithDevTools({
      trace: true,
      traceLimit: 25,
    })
    return createStore(rootReducer, composeEnhancers(...enhancers))
  }

  return createStore(rootReducer, composeWithDevTools(...enhancers))
}
